import { combineReducers, configureStore } from '@reduxjs/toolkit'
import logger from 'redux-logger'
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import batchReducer from './ReduxSlices/batchSlice';
import specimenReducer from './ReduxSlices/specimenSlice';
import patientReducer from './ReduxSlices/patientSlice';
import compWellnessPatientReducer from './ReduxSlices/compWellnessPatientSlice';

const middleWares: any = [];

if (process.env.NODE_ENV !== "production") {
  middleWares.push(logger);
}

const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({ 
  batches: batchReducer,
  specimens: specimenReducer,
  lumiPatients: patientReducer,
  compWellnessPatients: compWellnessPatientReducer 
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }).concat(middleWares)
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch